var React = require('react');

function Burger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 1.5L16 1.5","stroke":"#141414","strokeWidth":"1.7","key":0}),React.createElement("path",{"d":"M0 7.5L16 7.5","stroke":"#141414","strokeWidth":"1.7","key":1})]);
}

Burger.defaultProps = {"width":"16","height":"9","viewBox":"0 0 16 9","fill":"none"};

module.exports = Burger;

Burger.default = Burger;
